import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ant-upload-drag-icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ant-upload-drag-icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste os arquivos até aqui", -1)
const _hoisted_8 = { class: "ant-upload-list ant-upload-list-text" }
const _hoisted_9 = { class: "ant-upload-list-text-container" }
const _hoisted_10 = { class: "ant-upload-list-item-info" }
const _hoisted_11 = { class: "ant-upload-span" }
const _hoisted_12 = { class: "ant-upload-text-icon" }
const _hoisted_13 = {
  role: "img",
  "aria-label": "paper-clip",
  class: "anticon anticon-paper-clip"
}
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "ant-upload-list-item-card-actions"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  role: "img",
  "aria-label": "delete",
  class: "anticon anticon-delete"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-upload-list-item-progress",
  style: {"display":"none"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!

  return (_openBlock(), _createElementBlock("div", null, [
    ((!_ctx.props.editavel && _ctx.computedAnexosNotaFiscal.length <= 0))
      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
          key: 0,
          mensagem: "Nenhum anexo foi adicionado."
        }))
      : _createCommentVNode("", true),
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
          class: "ant-upload ant-upload-drag",
          onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("input", {
              id: "selecionarAnexoNotaFiscal",
              type: "file",
              accept: "",
              multiple: "",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarArquivos && _ctx.enviarArquivos(...args))),
              style: {"display":"none"}
            }, null, 32),
            _createElementVNode("div", {
              class: "ant-upload-drag-container",
              onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
            }, [
              ((_ctx.state.enviandoArquivos || _ctx.state.excluindoArquivos))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, [
                      _createVNode(_component_a_spin, { size: "large" })
                    ]),
                    _hoisted_4
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, [
                      _createVNode(_component_icone, {
                        style: {"font-size":"40px"},
                        nome: "upload-nuvem"
                      })
                    ]),
                    _hoisted_7
                  ]))
            ], 32)
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedAnexosNotaFiscal, (anexo) => {
          return (_openBlock(), _createElementBlock("div", {
            key: anexo.codigoArquivo,
            class: "ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_icone, { nome: "anexo" })
                  ])
                ]),
                _createElementVNode("a", {
                  class: "ant-upload-list-item-name",
                  title: anexo.arquivo.nome,
                  onClick: ($event: any) => (_ctx.visualizarAnexo(anexo.arquivo))
                }, _toDisplayString(anexo.arquivo.nome + '  -  ' + anexo.arquivo.tamanhoApresentacao), 9, _hoisted_14),
                (_ctx.props.editavel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.confirmaExclusao(anexo)),
                        class: "ant-btn ant-btn-text ant-btn-sm ant-upload-list-item-card-actions-btn ant-btn-icon-only",
                        title: "Remover"
                      }, [
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(_component_icone, { nome: "excluir" })
                        ])
                      ], 8, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_18
          ]))
        }), 128))
      ])
    ])
  ]))
}